<app-toast-container aria-live="polite" aria-atomic="true"></app-toast-container>
<router-outlet></router-outlet>
<app-new-version-notice></app-new-version-notice>
